import React, { useState, useRef, useEffect } from "react";
import { Button } from "Components/Button";
import KeyboardHint from "Components/KeyboardHint";
import ErrorMessage from "Components/ErrorMessage";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { marketingChannelData } from "Data";
import formStyles from "Styles/CompanySize.module.css";
import inputStyles from "Styles/Inputs.module.css";
import styles from "Styles/components/CheckboxWithOther.module.css";

const MarketingChannelFormContent = ({
  submitCB = () => {},
  defaultChannels = [],
  defaultOther = "",
}) => {
  const [checkedValues, setCheckedValues] = useState(defaultChannels || []);
  const [otherValue, setOtherValue] = useState(defaultOther || "");
  const [otherError, setOtherError] = useState("");
  const otherInputRef = useRef(null);

  useEffect(() => {
    if (defaultChannels && defaultChannels.length > 0) {
      setCheckedValues(defaultChannels);
    }
  }, [defaultChannels]);

  useEffect(() => {
    if (defaultOther) {
      setOtherValue(defaultOther);
    }
  }, [defaultOther]);

  const isOtherChecked = checkedValues.includes("other");
  const regularOptions = marketingChannelData.filter(
    (item) => item.value !== "other",
  );
  const otherOption = marketingChannelData.find(
    (item) => item.value === "other",
  );

  const handleCheck = (value) => {
    if (checkedValues.includes(value)) {
      setCheckedValues((prev) => prev.filter((item) => item !== value));
      if (value === "other") {
        setOtherValue("");
        setOtherError("");
      }
    } else {
      setCheckedValues((prev) => [...prev, value]);
      if (value === "other") {
        setTimeout(() => otherInputRef.current?.focus(), 0);
      }
    }
  };

  const handleOtherChange = (e) => {
    const newValue = e.target.value;
    setOtherValue(newValue);

    if (otherError) {
      setOtherError("");
    }

    if (!isOtherChecked && newValue) {
      setCheckedValues((prev) => [...prev, "other"]);
    } else if (isOtherChecked && !newValue.trim()) {
      setCheckedValues((prev) => prev.filter((item) => item !== "other"));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedOther = (otherValue || "").trim();
    if (isOtherChecked && !trimmedOther) {
      setOtherError("已選擇「其他」，請填寫內容");
      otherInputRef.current?.focus();
      return;
    }
    if (otherError) {
      setOtherError("");
    }
    submitCB({
      channels: checkedValues,
      otherChannel: isOtherChecked ? trimmedOther : "",
    });
  };

  return (
    <InfoContentMotionWrapper>
      <div className={formStyles.content}>
        <fieldset className={inputStyles.fieldset}>
          <legend className={inputStyles.legend}>至少選擇一個</legend>
          <form className={inputStyles.form} onSubmit={handleSubmit}>
            <div className={styles.checkboxWrapper}>
              {regularOptions.map((item) => {
                const isChecked = checkedValues.includes(item.value);
                return (
                  <React.Fragment key={item.value}>
                    <input
                      id={`channel-${item.value}`}
                      type="checkbox"
                      value={item.value}
                      checked={isChecked}
                      onChange={() => handleCheck(item.value)}
                      className={styles.hiddenInput}
                    />
                    <label
                      htmlFor={`channel-${item.value}`}
                      className={`${styles.checkboxLabel} ${isChecked ? styles.checked : ""}`}
                    >
                      {item.label}
                    </label>
                  </React.Fragment>
                );
              })}

              {otherOption && (
                <>
                  <input
                    id="channel-other"
                    type="checkbox"
                    value="other"
                    checked={isOtherChecked}
                    onChange={() => handleCheck("other")}
                    className={styles.hiddenInput}
                  />
                  <label
                    htmlFor="channel-other"
                    className={`${styles.checkboxLabel} ${styles.otherLabel} ${isOtherChecked ? styles.checked : ""}`}
                  >
                    <span>其他：</span>
                    <input
                      ref={otherInputRef}
                      type="text"
                      className={styles.otherInput}
                      value={otherValue}
                      onChange={handleOtherChange}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </label>
                </>
              )}
            </div>

            {otherError && <ErrorMessage text={otherError} />}

            <div style={{ display: "flex", alignItems: "end", gap: "0.75rem" }}>
              <Button
                disabled={checkedValues.length < 1}
                marginTop
                type="action"
                submit
              >
                OK
              </Button>
              <KeyboardHint />
            </div>
          </form>
        </fieldset>
      </div>
    </InfoContentMotionWrapper>
  );
};

export default MarketingChannelFormContent;
